export default __webpack_public_path__ + "static/media/904.2c32bc66.jpg";